<template>


  <div>


  <el-carousel :interval="5000" height="380px" arrow="always" >
    <el-carousel-item v-for="item in list" :key="item">

      <router-link :to="{ path: item.link }">
      <el-image
        style="width: 100%; height: 380px"
        :src="item.url" ></el-image>

      </router-link>
    </el-carousel-item>
  </el-carousel>



    <el-card  :body-style="{ padding: '10px',paddingBottom:'20px' }" >


      <el-row :gutter="20">

        <el-col :span="4">
          <el-button  class="welcome_button" type="primary" icon="el-icon-edit-outline"  @click="$router.push('/salary/salaryUpload')">薪资上传</el-button>
        </el-col>
        <el-col :span="4">
          <el-button class="welcome_button"  type="primary" icon="el-icon-edit-outline" @click="$router.push('/salary/salaryList')">薪资查询</el-button>
        </el-col>
        <el-col :span="4">
          <el-button class="welcome_button" type="primary" icon="el-icon-edit-outline" @click="$router.push('/company')" >企业信息</el-button>
        </el-col>
        <el-col :span="4">
          <el-button class="welcome_button"  type="primary" icon="el-icon-edit-outline" @click="$router.push('/config/explain')">使用说明</el-button>
        </el-col>

      </el-row>


    </el-card>



</div>

</template>

<script>
  export default {
    data () {
      return {
        size: '',
        list:[
          {
            url:"https://hnmykj.oss-cn-hangzhou.aliyuncs.com/xzcx/images/home/home.jpeg",
            link: '/config/Explain'
          }

        ]
      };
    },
    methods:{

      linkTo(){
        // let activeIndex = this.$refs.carousel.activeIndex


        console.log(this.$refs.carousel)
        this.$router.push(this.imgs[activeIndex].link)
      }

    }
  }
</script>


<style>
  .el-carousel__item h3 {
    color: #475669;
    font-size: 18px;
    opacity: 0.75;
    line-height: 300px;
    margin: 0;
  }


  .welcome_button{
    width: 150px;
    height: 100px;
  }

</style>



// WEBPACK FOOTER //
// src/components/Welcome.vue